module.exports = __webpack_public_path__ + "img/banner4.01d56b6e.png";